import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Profile from "../utils/Profile";
import profileAction from "./../../redux/profile/actions";
import dashboardActions from "../../redux/dashboard/actions";
import authActions from "../../redux/auth/actions";
import Modal from "../utils/Model";
import Button from "../utils/Button";
import { isAdmin, formatDigits } from "../../helpers/commonFunction";
import Loader from "../utils/Loader";
import moment from "moment-timezone";

const { openEditProfileModel, openChangePasswordModel } = profileAction;
const { getUserDataByToken, logout: logoutAction } = authActions;
const {
  openJarStatusModel,
  closeJarStatusModel,
  jarRunningStatus,
  openISPJarStatusModel,
  closeISPJarStatusModel,
  updateIspJarRunningStatus,
} = dashboardActions;

function Header() {
  const dispatch = useDispatch();
  const [accountBalance, setAccountBalance] = useState(0);
  const profileList = useSelector((state) => state.profile.profileListResult);
  const {
    tokenData,
    logoutMessage,
    loading: getUserByTokenLoading,
  } = useSelector((state) => state.auth);
  const {
    showJarStatusModal,

    showISPJarStatusModal,
    ispJarLoading,
    jarStatusLoading,
  } = useSelector((state) => state.dashboard);
  const { activationRequestResult } = useSelector(
    (state) => state.activationRequest,
  );
  const [switchAction, setSwitchAction] = useState(false);
  const [switchISPAction, setSwitchISPAction] = useState(false);
  const [laTime, setLaTime] = useState(
    moment()
      .tz(`${process.env.REACT_APP_DISPLAY_TIMEZONE}`)
      .format(`${process.env.REACT_APP_LONG_TIME_FORMAT}`),
  );

  const {
    handleSubmit,

    formState: { errors },
  } = useForm({});
  const {
    register: registerform,
    handleSubmit: handleISPSubmit,
    formState: { errorsform },
  } = useForm({});

  useEffect(() => {
    dispatch(getUserDataByToken());
  }, []);

  useEffect(() => {
    tokenData &&
      tokenData.length > 0 &&
      tokenData.map((data) => {
        localStorage.setItem("version_code", data.VersionCode);
        setAccountBalance(data.AccountBalance);
        setSwitchAction(data.JARFlag === 1 ? true : false);
        setSwitchISPAction(data.ISPJARFlag === 1 ? true : false);
      });
  }, [tokenData, activationRequestResult]);

  const isAdminUser = useMemo(() => {
    return tokenData && tokenData.length > 0 && isAdmin(tokenData);
  }, [tokenData]);

  const handleEditProfileModel = () => {
    dispatch(openEditProfileModel());
  };

  const handleChangePassword = () => {
    dispatch(openChangePasswordModel());
  };

  useEffect(() => {
    if (logoutMessage) {
      localStorage.clear();
      window.location.href = "/sign-in";
    }
  }, [logoutMessage]);

  const handleSignOut = () => {
    sessionStorage.clear();
    let tok = localStorage.getItem("mvno_admin_token");
    dispatch(
      logoutAction({
        token: tok,
      }),
    );
  };

  const switchHandler = (item) => {
    dispatch(openJarStatusModel());
  };
  const closeNetworkModal = () => {
    dispatch(closeJarStatusModel());
  };

  const onSubmit = () => {
    dispatch(closeJarStatusModel());
    const data = {
      UpdatedStatus: switchAction == true ? 0 : 1,
    };
    dispatch(jarRunningStatus(data));
    setSwitchAction((pre) => !pre);
  };

  const switchHandlerForISp = () => {
    dispatch(openISPJarStatusModel());
  };

  const closeISPJarModal = () => {
    dispatch(closeISPJarStatusModel());
  };

  const onISPSubmit = () => {
    dispatch(closeISPJarStatusModel());
    const data = {
      UpdatedStatus: switchISPAction == true ? 0 : 1,
    };
    dispatch(updateIspJarRunningStatus(data));
    setSwitchISPAction((pre) => !pre);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setLaTime(
        moment()
          .tz(`${process.env.REACT_APP_DISPLAY_TIMEZONE}`)
          .format(`${process.env.REACT_APP_LONG_TIME_FORMAT}`),
      );
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {getUserByTokenLoading && <Loader />}
      <div class="iq-top-navbar">
        <div class="iq-navbar-custom">
          <div class="iq-sidebar-logo">
            <div class="top-logo">
              <a href="index.html" class="logo">
                <img src="images/logo.gif" class="img-fluid" alt="" />
                <span>No Limit Wireless</span>
              </a>
            </div>
          </div>
          <nav class="navbar navbar-expand-lg navbar-light p-0">
            <button
              class="navbar-toggler collapsed mr-3"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-label="Toggle navigation"
              aria-expanded="false"
            >
              <i class="ri-menu-3-line"></i>
            </button>
            <div class="iq-menu-bt align-self-center">
              <div class="wrapper-menu">
                <div class="main-circle">
                  <i class="ri-arrow-left-s-line"></i>
                </div>
                <div class="hover-circle">
                  <i class="ri-arrow-right-s-line"></i>
                </div>
              </div>
            </div>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto navbar-list"></ul>
            </div>

            <ul class="navbar-list">
              <li>
                <a
                  href="#"
                  className="search-toggle iq-waves-effect d-flex align-items-center "
                >
                  <div
                    className="rounded-circle d-flex"
                    style={{
                      paddingTop: "3px",
                      background: "#004ca4",
                      color: "white",
                    }}
                  >
                    {profileList && profileList.length > 0
                      ? profileList[0].Username.charAt(0).toUpperCase()
                      : ""}
                  </div>
                </a>

                <div class="iq-sub-dropdown iq-user-dropdown">
                  <div class="iq-card shadow-none m-0">
                    <div class="iq-card-body p-0 ">
                      <div
                        className="user-dropdown-header text-center"
                        style={{
                          background: "linear-gradient(135deg,#0B3D91,#1E64D6)",
                          padding: "20px 0px 60px",
                          borderRadius: "18px 18px 0 0",
                          position: "relative",
                        }}
                      >
                        <div
                          style={{
                            width: 50,
                            height: 50,
                            borderRadius: "50%",
                            background: "#fff",
                            color: "#0B3D91",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "auto",
                            fontSize: 20,
                            fontWeight: 600,
                            boxShadow: "0 8px 20px rgba(0,0,0,.15)",
                          }}
                        >
                          <i className="ri-user-3-line"></i>
                        </div>
                        <h5 className="text-white mt-3 mb-1">
                          Hello {profileList?.[0]?.Username}
                        </h5>
                        <small className="text-white-50">
                          {profileList?.[0]?.Role}
                        </small>
                        <div
                          style={{
                            position: "absolute",
                            left: "50%",
                            transform: "translateX(-50%)",
                            bottom: "-28px",
                            background: "#fff",
                            width: "85%",
                            borderRadius: 15,
                            padding: "10px",
                            boxShadow: "0 10px 25px rgba(0,0,0,.12)",
                          }}
                        >
                          <small className="text-muted d-block">
                            Available Balance
                          </small>
                          <h4
                            style={{
                              color: "#0B3D91",
                              margin: 0,
                              fontWeight: 700,
                            }}
                          >
                            {Number(accountBalance) < 0
                              ? `$(${formatDigits(Number(Math.abs(accountBalance)).toFixed(2))})`
                              : `$${formatDigits(Number(accountBalance).toFixed(2))}`}
                          </h4>
                        </div>
                      </div>
                      <a
                        href="/my-profile"
                        class="iq-sub-card iq-bg-primary-hover mt-5"
                      >
                        <div class="media align-items-center">
                          <div
                            class="rounded-circle iq-card-icon"
                            style={{ background: "#e8f2fe", color: "black" }}
                          >
                            <i class="ri-file-user-line"></i>
                          </div>
                          <div class="media-body ml-3">
                            <h6 class="mb-0">My Profile</h6>
                            <p class="mb-0 font-size-12">
                              View personal profile details.
                            </p>
                          </div>
                        </div>
                      </a>
                      <a
                        onClick={handleEditProfileModel}
                        style={{ cursor: "pointer" }}
                        class="iq-sub-card iq-bg-primary-hover"
                      >
                        <div class="media align-items-center">
                          <div
                            class="rounded-circle iq-card-icon "
                            style={{ background: "#e8f2fe", color: "black" }}
                          >
                            <i class="ri-profile-line"></i>
                          </div>
                          <div class="media-body ml-3">
                            <h6 class="mb-0 ">Edit Profile</h6>
                            <p class="mb-0 font-size-12">
                              Modify your personal details.
                            </p>
                          </div>
                        </div>
                      </a>
                      <a
                        onClick={handleChangePassword}
                        style={{ cursor: "pointer" }}
                        class="iq-sub-card iq-bg-primary-hover"
                      >
                        <div class="media align-items-center">
                          <div
                            class="rounded-circle iq-card-icon"
                            style={{ background: "#e8f2fe", color: "black" }}
                          >
                            <i class="ri-account-box-line"></i>
                          </div>
                          <div class="media-body ml-3">
                            <h6 class="mb-0 ">Change Password</h6>
                            <p class="mb-0 font-size-12">
                              Modify your password.
                            </p>
                          </div>
                        </div>
                      </a>

                      <div className="d-inline-block w-100 text-center p-3 col-md-12 text-white">
                        <button
                          className="w-100"
                          style={{
                            background:
                              "linear-gradient(135deg,#0B3D91,#1E64D6)",
                            border: "none",
                            borderRadius: "30px",
                            height: "40px",
                            color: "#fff",
                          }}
                          onClick={handleSignOut}
                        >
                          Sign Out <i className="ri-logout-box-r-line ml-2"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
            <Profile />
          </nav>
        </div>
        <Modal
          showModal={showJarStatusModal}
          title={"Update Bot Status"}
          onHide={closeNetworkModal}
          width={550}
          showFooter={false}
        >
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="col-md-12 mb-1 p-0 text-dark">
              {switchAction == true ? (
                <p>Are you sure, you want to stop Bot?</p>
              ) : (
                <p>Are you sure, you want to start Bot?</p>
              )}
            </div>
            <div className="text-right row my-2">
              <div className="col-md-12">
                <button
                  type="button"
                  className="btn btn-secondary mr-2"
                  onClick={closeNetworkModal}
                >
                  Cancel
                </button>
                <Button
                  title={"Ok"}
                  buttonClass="btn btn-primary"
                  buttonType="submit"
                  loading={jarStatusLoading}
                />
              </div>
            </div>
          </form>
        </Modal>

        <Modal
          showModal={showISPJarStatusModal}
          title={"Update ISP Bot Status"}
          onHide={closeISPJarModal}
          width={550}
          showFooter={false}
        >
          <form onSubmit={handleISPSubmit(onISPSubmit)}>
            <div className="col-md-12 mb-1 p-0 text-dark">
              {switchISPAction == true ? (
                <p>Are you sure, you want to stop ISP Bot?</p>
              ) : (
                <p>Are you sure, you want to start ISP Bot?</p>
              )}
            </div>
            <div className="text-right row my-2">
              <div className="col-md-12">
                <button
                  type="button"
                  className="btn btn-secondary mr-2"
                  onClick={closeISPJarModal}
                >
                  {" "}
                  Cancel{" "}
                </button>
                <Button
                  title={"Ok"}
                  buttonClass="btn btn-primary"
                  buttonType="submit"
                  loading={ispJarLoading}
                />
              </div>
            </div>
          </form>
        </Modal>
      </div>
    </>
  );
}

export default Header;
